import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { usePagination } from 'hooks/usePagination';
import { useBoundStore } from 'useStore';
import { fetchForecastData } from '../services/fetchForecastData';
import useCountriesData from 'views/Components/Shared/Queries/countriesQuery';
import useUsersData from 'views/Components/Shared/Queries/usersQuery';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';

export default function useForecastData() {
	const { user, accessToken } = useAuth();
	const countriesQuery = useCountriesData();
	const usersQuery = useUsersData();

	const { paginationModel } = usePagination();
	const selectedMarketplace = useBoundStore(
		(state) => state.forecastSelectedMarketplace
	);
	const selectedYear = useBoundStore((state) => state.forecastSelectedYear);
	const selectedOwner = useBoundStore((state) => state.forecastSelectedOwner);
	const selectedCategory = useBoundStore(
		(state) => state.forecastSelectedCategory
	);
	const selectedBrand = useBoundStore((state) => state.forecastSelectedBrand);
	const search = useBoundStore((state) => state.forecastSearch);
	const currentMasterCountry = useCurrentMasterCountry();
	const countryId = currentMasterCountry?.id;
	const selectedKam = useBoundStore((state) => state.forecastSelectedKam);

	if (countriesQuery.status === 'error') {
		throw Error('Error en consulta de países');
	}

	const enabled =
		!user?.permissions?.includes('Forecast:viewAdmin') ||
		(user?.permissions?.includes('Forecast:viewAdmin') &&
			user?.permissions?.includes('Forecast:viewFilter'))
			? countriesQuery.status === 'success'
			: countriesQuery.status === 'success' &&
			  usersQuery.status === 'success' &&
			  selectedOwner !== 0;

	const forecastQuery = useQuery({
		queryKey: [
			'forecast',
			{
				limit: paginationModel.pageSize,
				offset: paginationModel.page,
				countryId,
				year: selectedYear,
				mktplaceId: selectedMarketplace,
				ownerId: selectedOwner,
				category: selectedCategory,
				search: search,
				brand: selectedBrand,
				kam: selectedKam,
			},
		],
		queryFn: () =>
			fetchForecastData({
				accessToken,
				limit: paginationModel.pageSize,
				offset: paginationModel.page,
				countryId,
				year: selectedYear,
				mktplaceId: selectedMarketplace,
				ownerId: selectedOwner,
				category: selectedCategory,
				search: search,
				brand: selectedBrand,
				kam: selectedKam,
			}),
		staleTime: Infinity,
		enabled,
		retry: false,
		placeholderData: (previousData) => previousData,
	});

	return forecastQuery;
}
